export default __webpack_public_path__ + "static/media/8.f92e0325.jpg";